import { createSlice } from '@reduxjs/toolkit';
import { fetchAdminClientUserManagement } from './features';

export const adminClientUserManagement = createSlice({
  name: 'adminClientUserManagement',
  initialState: {
    userList: [],
    isLoading: true,
    isError: true,
  },
  reducers: {
    removeGlobalUser: (state, action) => {
      state.userList = state.userList.filter(
        (item) => item.mail !== action.payload
      );
    },
    addUser: (state, action) => {
      state.userList = [action.payload, ...state.userList];
    },
    updateUser: (state, action) => {
      const searchMail = action.payload._originalMail || action.payload.mail;
      const index = state.userList.findIndex(
        (user) => user.mail === searchMail
      );
      if (index > -1) {
        const newArray = [...state.userList];
        const { _originalMail, ...cleanPayload } = action.payload;
        newArray[index] = cleanPayload;
        state.userList = [...newArray];
      }
    },
    userActivation: (state, { payload }) => {
      const index = state.userList.findIndex(
        (user) => user.mail === payload.mail
      );
      if (index > -1) {
        const newArray = [...state.userList];
        let object = { ...newArray[index] };
        object[payload.key] = !payload.value;
        newArray[index] = { ...object };
        state.userList = [...newArray];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchAdminClientUserManagement.fulfilled,
        (state, { payload }) => {
          state.userList = payload;
          state.isLoading = false;
          state.isError = false;
        }
      )
      .addCase(fetchAdminClientUserManagement.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchAdminClientUserManagement.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export default adminClientUserManagement.reducer;

export const adminClientUserManagementSelector = (state) =>
  state.adminClientUserManagement;

export const { removeGlobalUser, addUser, updateUser, userActivation } =
  adminClientUserManagement.actions;
